/**
 * @param breakpoint
 */
export const isBelowViewportSize = (breakpoint) => {
  return window.innerWidth < breakpoint;
};

export const breakpoints = {
  desktop: 1025,
};
